import { generate } from '@ant-design/colors';
import { TinyColor } from '@ctrl/tinycolor';
import { defaultPresetColors } from '../seed';
import genColorMapToken from '../shared/genColorMapToken';
import genCommonMapToken from '../shared/genCommonMapToken';
import { generateBgPalettes, generateErrorPalettes, generateInfoPalettes, generatePrimaryPalettes, generateSuccessPalettes, generateTextAlphaPalettes, generateWarningPalettes, } from './palettes';
export default function derivative(token) {
    const { colorSuccess, colorWarning, colorError, colorInfo } = token;
    const colorPalettes = Object.keys(defaultPresetColors)
        .map((colorKey) => {
        const colors = generate(token[colorKey], { theme: 'dark' });
        return new Array(10).fill(1).reduce((prev, _, i) => {
            prev[`${colorKey}-${i + 1}`] = colors[i];
            return prev;
        }, {});
    })
        .reduce((prev, cur) => {
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    const colorPrimary = token.colorPrimary || '#177ddc';
    const colorBgBase = token.colorBgBase || '#000';
    const colorTextBase = token.colorTextBase || '#fff';
    const primaryColors = generatePrimaryPalettes(colorPrimary);
    const successColors = generateSuccessPalettes(colorSuccess);
    const warningColors = generateWarningPalettes(colorWarning);
    const errorColors = generateErrorPalettes(colorError);
    const infoColors = generateInfoPalettes(colorInfo);
    const bgColors = generateBgPalettes(colorBgBase);
    const textColors = generateTextAlphaPalettes(colorTextBase);
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), { colorPrimary }), genColorMapToken({
        primaryPalettes: primaryColors,
        successPalettes: successColors,
        warningPalettes: warningColors,
        errorPalettes: errorColors,
        infoPalettes: infoColors,
        bgPalettes: bgColors,
        textAlphaPalettes: textColors,
    })), { colorPrimaryOutline: new TinyColor(colorPrimary).setAlpha(0.2).toRgbString(), colorErrorOutline: new TinyColor(colorError).setAlpha(0.2).toRgbString(), colorWarningOutline: new TinyColor(colorWarning).setAlpha(0.2).toRgbString() }), genCommonMapToken(token));
}
